import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  href: string
  light?: boolean
}>

export const Chip: React.FC<Props> = ({ href, children, light = false }) => (
  <a
    className={`inline-block rounded-[4px] border-gray-300 bg-gray-50 px-2 py-[6px] text-[11px] leading-[1.2] xl:rounded-[2px] xl:border xl:bg-white xl:px-3 xl:text-[12px] xl:hover:bg-gray-60 ${
      light ? 'bg-white' : 'border'
    }`}
    href={href}
  >
    {children}
  </a>
)
